<template>
  <div>
    <page-header title="Ответственное хранение"/>
    <div class="public-container">
      <safe-custody-info/>
      <safe-custody-cases class="public-container-mobile"/>
      <public-info-grid
        id="advantages"
        :items="items"
        :title="content.blocks?.advantages.title"
        class="safe-custody-advantages public-container-mobile"
      />
      <div id="price" class="mb-90 public-container-mobile">
        <h2 class="vz-text-align-left">{{ content.blocks?.price.priceTitle }}</h2>
        <ul class="public-list public-list-square">
          <li v-for="text in content.blocks?.price.list.split(';')">
            <span>{{ text }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import SafeCustodyInfo from '~/components/public/safe-custody/safe-custody-info.vue';
import SafeCustodyCases from '~/components/public/safe-custody/safe-custody-cases.vue';
import PublicInfoGrid from '~/components/public/public-info-grid.vue';
import {PublicInfoGridItem} from '~/types/public';
import {getPageContent} from '~/api/content';

const content = await getPageContent('/safe-custody')

const items = computed((): PublicInfoGridItem[] => [
  {
    title: content.blocks?.advantages.secureTitle,
    text: content.blocks?.advantages.secureText,
    icon: {
      url: '/svg/vz-security.svg'
    }
  },
  {
    title: content.blocks?.advantages.timeTitle,
    text: content.blocks?.advantages.timeText,
    icon: {
      url: '/svg/vz-time-success.svg'
    }
  },
  {
    title: content.blocks?.advantages.paymentTitle,
    text: content.blocks?.advantages.paymentText,
    icon: {
      url: '/svg/vz-coins.svg'
    }
  },
  {
    title: content.blocks?.advantages.complexTitle,
    text: content.blocks?.advantages.complexText,
    icon: {
      url: '/svg/vz-cup.svg'
    }
  },
])
</script>

<style scoped lang="scss">
.safe-custody-advantages {
  margin-top: 110px;
  margin-bottom: 110px;
}
</style>
